export default class AdminDocenteLista {

    /**
     *
     * @param {string} data.empresaId
     * @param {string} data.empresaNombre
     */
    constructor(data) {
        $('#btn-nuevo-docente').click(function() {
            let form = new AdminDocenteForm(data);
            form.nuevo({
                onSuccess: function() {
                    window.location.reload();
                }
            });
        });

        $('.btn-editar').click(function() {
            let form = new AdminDocenteForm(data);
            form.editar(this.parentNode.dataset.id, {
                onSuccess: function(response) {
                    window.location.reload();
                }
            });
        });

        $('#btn-importar').click(function() {
            let form = new AdminDocenteImportarForm(data);
            form.nuevo({
                onSuccess: function(res) {
                    window.location.reload();
                }
            });
        });
    }
}
